import { fetchAPI } from "@coworker/app/src/hooks/API/data.service";

export const fetchCountriesWith4A1KData = async () => {
  return (
    (await fetchAPI(`acesking/getAcesAndKingCountries`, "POST", "")) || [""]
  );
};
